import PropTypes from "prop-types"
import { useUserRole } from "hooks/users"
import Solution from "./components/solution"
import SigmaSolutions from "./components/sigma-solutions"
import { SOLUTIONS, SIGMA_SOLUTIONS } from "./shapes"
import "./style.scss"

function SolutionsModule({ solutions, sigmaSolutions, accountAlias, isSuperuser }) {
  const userRole = useUserRole()
  return (
    <div className="modules_solutions">
      <div className="solutions-main">
        <div className="solutions">
          {(isSuperuser || userRole === "admin") && solutions?.map((solution) => (
            <Solution key={solution.id} solution={solution} />
          ))}
        </div>
      </div>
      <SigmaSolutions sigmaSolutions={sigmaSolutions} accountAlias={accountAlias} isSuperuser={isSuperuser} />
    </div>
  )
}
SolutionsModule.propTypes = {
  solutions: SOLUTIONS.isRequired,
  sigmaSolutions: SIGMA_SOLUTIONS,
  accountAlias: PropTypes.string.isRequired,
  isSuperuser: PropTypes.bool.isRequired,
}

export default SolutionsModule
